import React, { useState } from "react";
import { Dialog } from "@mui/material";
import EmployeesTable from "./EmployeesTable";
import { Box, HStack, VStack } from "../../components/utils";
import JoiningYear from "./joiningYear";
import { useEmployees } from "../../queries/employees";
import Department from "./department";
import EmployeeTableFilters from "./employeeTableFilters";
import BCHeader from "../../shared/BCHeader";
import AddEmployee from "../../modals/AddEmployee";
import useIsMobile from "../../utils/detectDevice";

function AllEmployees(): React.ReactElement {
  const [open, setOpen] = useState<boolean>(false);
  const { data: employees } = useEmployees();
  const { isMobile } = useIsMobile();
  return (
    <VStack className="gap-4">
      <BCHeader
        className={`items-baseline ${isMobile ? "text-xs" : ""}`}
        bcTitle="All Option Holders"
        buttonName="Add Option Holder"
        onClick={() => setOpen(!open)}
      />
      <Dialog open={open} maxWidth="md">
        <div className="w-[900px] h-full">
          <AddEmployee onClose={() => setOpen(!open)} data={[]} />
        </div>
      </Dialog>
      <Box
        className={`grid w-full ${
          isMobile ? "grid-cols-1" : "grid-cols-2"
        } gap-4 rounded-lg `}
      >
        <Department title="Departments" />
        <JoiningYear title="Year of Joining" />
      </Box>
      <HStack className="w-full gap-4">
        {!isMobile && (
          <Box className="bg-white rounded-lg w-21 min-w-min">
            <EmployeeTableFilters />
          </Box>
        )}
        <Box className={`${isMobile ? "w-full overflow-x-auto" : "grow"} `}>
          {employees && <EmployeesTable data={employees} />}
        </Box>
      </HStack>
    </VStack>
  );
}

export default AllEmployees;
